export default __webpack_public_path__ + "static/media/pc_background_addtext@3x.82cb15ca.png";